module.exports = __webpack_public_path__ + "img/净网公约_竖.00965f9d.png";